import React from 'react';

import GalleryTemplate from './GalleryTemplate';
import LocationTemplate from './LocationTemplate';
import ImageTemplate from './ImageTemplate';
import EmbedTemplate from './EmbedTemplate';
import ApartmentsTemplate from './ApartmentsTemplate';
import ApartmentTypesTemplate from './ApartmentTypesTemplate';
import VideoTemplate from './VideoTemplate';
import ProjectsTemplate from './ProjectsTemplate';
import SingleColumnTemplate from './SingleColumnTemplate';
import TwoColumnTemplate from './TwoColumnTemplate';
import DoubleGalleryTemplate from './DoubleGalleryTemplate';
import ToggleGalleryTemplate from './ToggleGalleryTemplate';
import FAQTemplate from './FAQTemplate';

const PageTemplate = ({ page, ...props }) => {
    // If page has children, it should be handled by SubpageRouter
    // This is a fallback in case PageTemplate is called directly
    if (page?.children) {
        return (
            <div>
                <h1>This page has subpages</h1>
                <p>Please navigate using the sidebar menu.</p>
            </div>
        );
    }
    
    // Render the appropriate template for pages without children
    switch (page.template) {
        case 'gallery':
            return <GalleryTemplate page={page} {...props} />;
        case 'location':
            return <LocationTemplate page={page} {...props} />;
        case 'image':
            return <ImageTemplate page={page} {...props} />;
        case 'embed':
            return <EmbedTemplate page={page} {...props} />;
        case 'apartments':
            return <ApartmentsTemplate page={page} {...props} />;
        case 'apartment_types':
            return <ApartmentTypesTemplate page={page} {...props} />;
        case 'video':
            return <VideoTemplate page={page} {...props} />;
        case 'projects':
            return <ProjectsTemplate page={page} {...props} />;
        case 'single_column':
            return <SingleColumnTemplate page={page} {...props} />;
        case 'two_column':
            return <TwoColumnTemplate page={page} {...props} />;
        case 'gallery_double':
            return <DoubleGalleryTemplate page={page} {...props} />;
        case 'gallery_toggle':
            return <ToggleGalleryTemplate page={page} {...props} />;
        case 'faq':
            return <FAQTemplate page={page} {...props} />;
        default:
            return <div/>;
    }
};


export default PageTemplate;
